export var ChatMessageRole;
(function (ChatMessageRole) {
    ChatMessageRole["User"] = "user";
    ChatMessageRole["Assistant"] = "assistant";
    ChatMessageRole["Action"] = "action";
})(ChatMessageRole || (ChatMessageRole = {}));
export var NavigationRoute;
(function (NavigationRoute) {
    NavigationRoute["IncomeAdd"] = "income_add";
    NavigationRoute["ExpenseAdd"] = "expense_add";
    NavigationRoute["IncomeExpenseList"] = "income_expense_list";
    NavigationRoute["InvestmentCreate"] = "investment_create";
    NavigationRoute["InvestmentList"] = "investment_list";
    NavigationRoute["RealisationCreate"] = "realisation_create";
    NavigationRoute["RealisationList"] = "realisation_list";
    NavigationRoute["CapitalActionCreate"] = "capital_action_create";
    NavigationRoute["CapitalActionList"] = "capital_action_list";
    NavigationRoute["ManualJournalCreate"] = "manual_journal_create";
    NavigationRoute["ManualJournalList"] = "manual_journal_list";
    NavigationRoute["Commitments"] = "commitments";
    NavigationRoute["Accounting"] = "accounting";
    NavigationRoute["AccountingGeneralLedger"] = "accounting_general_ledger";
    NavigationRoute["AccountingTrialBalance"] = "accounting_trial_balance";
    NavigationRoute["AccountingBalanceSheet"] = "accounting_balance_sheet";
    NavigationRoute["AccountingIncomeStatement"] = "accounting_income_statement";
    NavigationRoute["AccountingCashFlowStatement"] = "accounting_cash_flow_statement";
    NavigationRoute["AccountingScheduleOfInvestments"] = "accounting_schedule_of_investments";
    NavigationRoute["BankReconciliation"] = "bank_reconciliation";
    NavigationRoute["BankReconciliationReconcile"] = "bank_reconciliation_reconcile";
    NavigationRoute["BankReconciliationStatement"] = "bank_reconciliation_statement";
    NavigationRoute["BankReconciliationReconciled"] = "bank_reconciliation_reconciled";
    NavigationRoute["BankReconciliationAccountSettings"] = "bank_reconciliation_account_settings";
    NavigationRoute["FundSetup"] = "fund_setup";
    NavigationRoute["FundSetupGeneral"] = "fund_setup_general";
    NavigationRoute["FundSetupChartOfAccounts"] = "fund_setup_chart_of_accounts";
    NavigationRoute["FundSetupAccountMapping"] = "fund_setup_account_mapping";
    NavigationRoute["FundSetupFeeSettings"] = "fund_setup_fee_settings";
    NavigationRoute["FundSetupCarrySettings"] = "fund_setup_carry_settings";
    NavigationRoute["FundSetupEqualisationInterest"] = "fund_setup_equalisation_interest";
    NavigationRoute["FirmSettings"] = "firm_settings";
    NavigationRoute["Vehicles"] = "vehicles";
    NavigationRoute["HoldingsList"] = "holdings_list";
    NavigationRoute["HoldingsCreate"] = "holdings_create";
    NavigationRoute["Equalisations"] = "equalisations";
    NavigationRoute["EqualisationsAdd"] = "equalisations_add";
    NavigationRoute["PartnerTransfers"] = "partner_transfers";
    NavigationRoute["PartnerTransfersCreate"] = "partner_transfers_create";
    NavigationRoute["PeriodEndReview"] = "period_end_review";
    NavigationRoute["Onboarding"] = "onboarding";
    NavigationRoute["OnboardingOverview"] = "onboarding_overview";
    NavigationRoute["OnboardingDocumentSigning"] = "onboarding_document_signing";
    NavigationRoute["OnboardingSettings"] = "onboarding_settings";
    NavigationRoute["FeeManager"] = "fee_manager";
    NavigationRoute["UserManagement"] = "user_management";
    NavigationRoute["InvestorUpdates"] = "investor_updates";
    NavigationRoute["PeriodEndReport"] = "period_end_report";
})(NavigationRoute || (NavigationRoute = {}));
export var ResponseSegmentType;
(function (ResponseSegmentType) {
    ResponseSegmentType["Text"] = "text";
    ResponseSegmentType["Navigation"] = "navigation";
    ResponseSegmentType["FileUpload"] = "fileUpload";
    ResponseSegmentType["ToolCall"] = "toolCall";
})(ResponseSegmentType || (ResponseSegmentType = {}));
//# sourceMappingURL=index.js.map